import { PaymentClient } from '@src/orders/services/PaymentClient';
import { useQuery } from '@tanstack/react-query';

export const useAvailableCurrencies = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['availableCurrencies'],
    queryFn: () => PaymentClient.listAvailableCurrencies(),
  });

  return { currencies: data ?? [], isLoading };
};
